import React from "react";
import Board from "./Board";
import { LIGHT } from "./parts";

// Light-theme flight board (white panels, blue accents).
const LightBoard = (props) => <Board {...props} theme={LIGHT} />;

export default LightBoard;
